import script from "./FooterMuco60.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterMuco60.vue?vue&type=script&setup=true&lang=js"

import "./FooterMuco60.vue?vue&type=style&index=0&id=08ce3eb4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ce3eb4"]])

export default __exports__